import { Link } from "react-router-dom";
import { ChevronRight, type LucideIcon } from "lucide-react";

export interface NavDropdownItem {
  icon: LucideIcon;
  title: string;
  description: string;
  href: string;
  moduleKey?: string;
}

interface NavDropdownPanelProps {
  items: NavDropdownItem[];
  isOpen: boolean;
  onItemClick?: () => void;
  className?: string;
  columns?: 1 | 2;
}

export default function NavDropdownPanel({
  items,
  isOpen,
  onItemClick,
  className = "",
  columns = 1,
}: NavDropdownPanelProps) {
  if (items.length === 0) return null;

  return (
    <div
      className={`absolute top-full left-1/2 -translate-x-1/2 pt-2 z-[60] ${className}`}
      style={{
        opacity: isOpen ? 1 : 0,
        transform: isOpen
          ? "translateX(-50%) translateY(0)"
          : "translateX(-50%) translateY(4px)",
        pointerEvents: isOpen ? "auto" : "none",
        transition: "opacity 180ms ease, transform 180ms ease",
      }}
    >
      <div className={`bg-popover border border-border/50 rounded-xl shadow-lg shadow-black/20 p-1.5 ${columns === 2 ? 'min-w-[560px]' : 'min-w-[272px]'}`}>
        <div className={columns === 2 ? 'grid grid-cols-2 gap-0.5' : ''}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.href + item.title}
              to={item.href}
              onClick={onItemClick}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors hover:bg-primary/5 group"
            >
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 shrink-0">
                <Icon className="h-4 w-4 text-primary" />
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-foreground leading-tight">
                  {item.title}
                </span>
                <span className="block text-xs text-muted-foreground leading-snug mt-0.5">
                  {item.description}
                </span>
              </span>
              <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50 opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0 shrink-0" />
            </Link>
          );
        })}
        </div>
      </div>
    </div>
  );
}
